var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTelemedicine = function SvgTelemedicine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Telemedicine_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__b",
    maskUnits: "userSpaceOnUse",
    x: -0.995,
    y: -1,
    width: 16,
    height: 26,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.995-1h16v26h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13 23.99h9.745a.375.375 0 1 0 0-.75H1.13a.375.375 0 0 1-.375-.375v-1.874h10.12a.375.375 0 1 0 0-.75H.756V2.25h12.744v8.621a.375.375 0 1 0 .75 0V1.124A1.124 1.124 0 0 0 13.125 0H1.13A1.125 1.125 0 0 0 .005 1.124v21.741A1.125 1.125 0 0 0 1.13 23.99Zm0-23.24h11.994a.375.375 0 0 1 .375.374V1.5H.755v-.375C.755.917.923.75 1.13.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.13 23.99h9.745a.375.375 0 1 0 0-.75H1.13a.375.375 0 0 1-.375-.375v-1.874h10.12a.375.375 0 1 0 0-.75H.756V2.25h12.744v8.621a.375.375 0 1 0 .75 0V1.124A1.124 1.124 0 0 0 13.125 0H1.13A1.125 1.125 0 0 0 .005 1.124v21.741A1.125 1.125 0 0 0 1.13 23.99Zm0-23.24h11.994a.375.375 0 0 1 .375.374V1.5H.755v-.375C.755.917.923.75 1.13.75Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13 23.99h9.745a.375.375 0 1 0 0-.75H1.13a.375.375 0 0 1-.375-.375v-1.874h10.12a.375.375 0 1 0 0-.75H.756V2.25h12.744v8.621a.375.375 0 1 0 .75 0V1.124A1.124 1.124 0 0 0 13.125 0H1.13A1.125 1.125 0 0 0 .005 1.124v21.741A1.125 1.125 0 0 0 1.13 23.99Zm0-23.24h11.994a.375.375 0 0 1 .375.374V1.5H.755v-.375C.755.917.923.75 1.13.75Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 5.377,
    y: 20.74,
    width: 3,
    height: 2,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.377 20.74h3v2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.752 21.74a.375.375 0 0 0 0 .75h.75a.375.375 0 1 0 0-.75h-.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.752 21.74a.375.375 0 0 0 0 .75h.75a.375.375 0 1 0 0-.75h-.75Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.752 21.74a.375.375 0 0 0 0 .75h.75a.375.375 0 1 0 0-.75h-.75Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__c)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 2.379,
    y: 7.246,
    width: 9,
    height: 9,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.379 7.246h9v9h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.003 15.743h2.249a.375.375 0 0 0 .374-.375v-1.874h1.875a.375.375 0 0 0 .375-.375V10.87a.375.375 0 0 0-.375-.375H8.626V8.621a.375.375 0 0 0-.374-.375h-2.25a.375.375 0 0 0-.374.375v1.874H3.754a.375.375 0 0 0-.375.375v2.249a.375.375 0 0 0 .375.375h1.874v1.874a.375.375 0 0 0 .375.375Zm-1.875-2.999v-1.5h1.875a.375.375 0 0 0 .374-.374V8.996h1.5v1.874a.375.375 0 0 0 .375.375h1.874v1.5H8.252a.375.375 0 0 0-.375.374v1.874h-1.5V13.12a.375.375 0 0 0-.374-.375H4.128Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.003 15.743h2.249a.375.375 0 0 0 .374-.375v-1.874h1.875a.375.375 0 0 0 .375-.375V10.87a.375.375 0 0 0-.375-.375H8.626V8.621a.375.375 0 0 0-.374-.375h-2.25a.375.375 0 0 0-.374.375v1.874H3.754a.375.375 0 0 0-.375.375v2.249a.375.375 0 0 0 .375.375h1.874v1.874a.375.375 0 0 0 .375.375Zm-1.875-2.999v-1.5h1.875a.375.375 0 0 0 .374-.374V8.996h1.5v1.874a.375.375 0 0 0 .375.375h1.874v1.5H8.252a.375.375 0 0 0-.375.374v1.874h-1.5V13.12a.375.375 0 0 0-.374-.375H4.128Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.003 15.743h2.249a.375.375 0 0 0 .374-.375v-1.874h1.875a.375.375 0 0 0 .375-.375V10.87a.375.375 0 0 0-.375-.375H8.626V8.621a.375.375 0 0 0-.374-.375h-2.25a.375.375 0 0 0-.374.375v1.874H3.754a.375.375 0 0 0-.375.375v2.249a.375.375 0 0 0 .375.375h1.874v1.874a.375.375 0 0 0 .375.375Zm-1.875-2.999v-1.5h1.875a.375.375 0 0 0 .374-.374V8.996h1.5v1.874a.375.375 0 0 0 .375.375h1.874v1.5H8.252a.375.375 0 0 0-.375.374v1.874h-1.5V13.12a.375.375 0 0 0-.374-.375H4.128Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__e",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 19.992,
    width: 5,
    height: 5,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.992h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.491a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm2.249 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.491a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm2.249 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.491a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm2.249 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__e)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__f",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16.992,
    width: 8,
    height: 8,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 16.992h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.032 18.834c.084.189.305.274.494.19a3.309 3.309 0 0 1 1.348-.282 3.378 3.378 0 0 1 3.373 3.373c.002.464-.095.924-.282 1.348a.375.375 0 1 0 .685.303c.23-.52.348-1.082.347-1.65a4.127 4.127 0 0 0-4.123-4.124 4.06 4.06 0 0 0-1.651.347.375.375 0 0 0-.191.495Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.032 18.834c.084.189.305.274.494.19a3.309 3.309 0 0 1 1.348-.282 3.378 3.378 0 0 1 3.373 3.373c.002.464-.095.924-.282 1.348a.375.375 0 1 0 .685.303c.23-.52.348-1.082.347-1.65a4.127 4.127 0 0 0-4.123-4.124 4.06 4.06 0 0 0-1.651.347.375.375 0 0 0-.191.495Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.032 18.834c.084.189.305.274.494.19a3.309 3.309 0 0 1 1.348-.282 3.378 3.378 0 0 1 3.373 3.373c.002.464-.095.924-.282 1.348a.375.375 0 1 0 .685.303c.23-.52.348-1.082.347-1.65a4.127 4.127 0 0 0-4.123-4.124 4.06 4.06 0 0 0-1.651.347.375.375 0 0 0-.191.495Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__g",
    maskUnits: "userSpaceOnUse",
    x: 10.991,
    y: 13.994,
    width: 11,
    height: 11,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.991 13.994h11v11h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.361 23.98a.375.375 0 0 0 .452-.277 6.82 6.82 0 0 0 .183-1.587 7.129 7.129 0 0 0-7.122-7.122 6.786 6.786 0 0 0-1.586.183.376.376 0 1 0 .175.729 6.06 6.06 0 0 1 1.411-.162 6.378 6.378 0 0 1 6.372 6.372c.002.475-.052.95-.162 1.412a.375.375 0 0 0 .277.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.361 23.98a.375.375 0 0 0 .452-.277 6.82 6.82 0 0 0 .183-1.587 7.129 7.129 0 0 0-7.122-7.122 6.786 6.786 0 0 0-1.586.183.376.376 0 1 0 .175.729 6.06 6.06 0 0 1 1.411-.162 6.378 6.378 0 0 1 6.372 6.372c.002.475-.052.95-.162 1.412a.375.375 0 0 0 .277.452Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.361 23.98a.375.375 0 0 0 .452-.277 6.82 6.82 0 0 0 .183-1.587 7.129 7.129 0 0 0-7.122-7.122 6.786 6.786 0 0 0-1.586.183.376.376 0 1 0 .175.729 6.06 6.06 0 0 1 1.411-.162 6.378 6.378 0 0 1 6.372 6.372c.002.475-.052.95-.162 1.412a.375.375 0 0 0 .277.452Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__g)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Telemedicine_svg__h",
    maskUnits: "userSpaceOnUse",
    x: 10.991,
    y: 10.994,
    width: 14,
    height: 14,
    fill: "#102B3F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.991 10.994h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.874 11.994a9.781 9.781 0 0 0-1.559.121.374.374 0 1 0 .12.74 9.382 9.382 0 0 1 10.81 9.26c0 .482-.037.963-.112 1.44a.374.374 0 1 0 .74.12 9.807 9.807 0 0 0 .122-1.56 10.131 10.131 0 0 0-10.121-10.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.874 11.994a9.781 9.781 0 0 0-1.559.121.374.374 0 1 0 .12.74 9.382 9.382 0 0 1 10.81 9.26c0 .482-.037.963-.112 1.44a.374.374 0 1 0 .74.12 9.807 9.807 0 0 0 .122-1.56 10.131 10.131 0 0 0-10.121-10.12Z",
    fill: "#102B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.874 11.994a9.781 9.781 0 0 0-1.559.121.374.374 0 1 0 .12.74 9.382 9.382 0 0 1 10.81 9.26c0 .482-.037.963-.112 1.44a.374.374 0 1 0 .74.12 9.807 9.807 0 0 0 .122-1.56 10.131 10.131 0 0 0-10.121-10.12Z",
    stroke: "#102B3F",
    strokeWidth: 0.2,
    mask: "url(#Telemedicine_svg__h)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Telemedicine_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102B3F",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgTelemedicine;